// Adapta um item do formulário novo (chaves minúsculas: tipo/opcoes/sufixo...) para
// o `param` que `renderControl` espera (Tipo/Opcoes/Sufixo..., herdado da tela
// antiga). Mesmo truque do IntegracaoTab do Admin.
export const PLACEHOLDER_SENHA_SALVA = "•••••• (salva, deixe em branco para manter)";

export function paramParaControle(param) {
  const tipo = (param && param.tipo) || "text";
  const senhaSalva = tipo === "password" && !!(param && param.hasValue);
  return {
    Id: param && param.idParametro,
    Tipo: tipo,
    Opcoes: param && param.opcoes,
    Sufixo: param && param.sufixo,
    Min: param && param.min,
    Max: param && param.max,
    Placeholder: senhaSalva ? PLACEHOLDER_SENHA_SALVA : (param && param.placeholder) || "",
  };
}

// "Ligado" na convenção do renderControl (Sim/true/1).
export function estaLigado(valor) {
  const v = String(valor === null || valor === undefined ? "" : valor).trim().toLowerCase();
  return v === "sim" || v === "true" || v === "1";
}
